import React, { useState } from "react";
import { Divider, ListItem } from "@mui/material";
import { ListItemButton, List, Menu, Fade  ,Button } from "@mui/material";
import Icon1 from "../../images/landing/icon 1.png";
import Icon2 from "../../images/landing/icon 2.png";
import Icon3 from "../../images/landing/icon 3.png";
import Icon4 from "../../images/landing/icon 4.png";
import Icon5 from "../../images/landing/icon 5.png";
import Icon6 from "../../images/landing/icon 6.png";
import Icon7 from "../../images/landing/icon 7.png";
import Logo from "../../images/managekaro logo.png";
import Drawer from "@mui/material/Drawer";
import { Stack, Toolbar, Box, AppBar, IconButton, Grid } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import { Link as Link2 } from "react-scroll";
import { Btn, MenuTitle } from "./style";
// import whatsAppIcon from "../../images/whatsAppIcon.png";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const drawerWidth = 240;

export default function LandingHeader() {
  const location = useLocation();
  let otherPath = location.pathname != "/" ? true : false;
  const [mobileOpen, setMobileOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClickWhatsapp = () => {
    const phoneNumber = "923315921209";
    const message = "Hello! I would like to inquire about your services.";
    const encodedMessage = encodeURIComponent(message || '');
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
};
  const drawer = (
    <div>
      <Toolbar>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Link to="/">
            <img style={{ width: "70%" }} src={Logo} alt="logo" />
          </Link>
        </Box>
      </Toolbar>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton sx={{ display: "flex", justifyContent: "center" }}>
            {otherPath ? (
              <Link to="/">
                <Btn variant="text">Home</Btn>
              </Link>
            ) : (
              <Link2
                to="home"
                spy={true}
                smooth={true}
                offset={0}
                duration={1000}
              >
                <Btn variant="text" onClick={toggle}>
                  Home
                </Btn>
              </Link2>
            )}
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton sx={{ display: "flex", justifyContent: "center" }}>
            <Link to="/about-us">
              <Btn variant="text" onClick={toggle}>
                About Us
              </Btn>
            </Link>
          </ListItemButton>
        </ListItem>

        {/* <ListItem disablePadding>
          <ListItemButton sx={{ display: "flex", justifyContent: "center" }}>
            <Link to="/pricing">
              <Btn variant="text" onClick={toggle}>
                Pricing
              </Btn>
            </Link>
          </ListItemButton>
        </ListItem> */}

        {!otherPath && (
          <ListItem disablePadding>
            <ListItemButton sx={{ display: "flex", justifyContent: "center" }}>
              {otherPath ? (
                <Link to="/">
                  <Btn variant="text">Home</Btn>
                </Link>
              ) : (
                <Link2
                  to="partners"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={1000}
                >
                  <Btn variant="text" onClick={toggle}>
                    Our Partners
                  </Btn>
                </Link2>
              )}
            </ListItemButton>
          </ListItem>
        )}
        <ListItem disablePadding>
          <ListItemButton sx={{ display: "flex", justifyContent: "center" }}>
            <Btn
              id="fade-button"
              aria-controls={open ? "fade-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              Features
            </Btn>
          </ListItemButton>
        </ListItem>
        {/* <ListItem disablePadding>
          <ListItemButton sx={{ display: "flex", justifyContent: "center" }}>
            <Link to="/pricing">
              <Btn onClick={toggle}>Pricing</Btn>
            </Link>
          </ListItemButton>
        </ListItem> */}
        <ListItem disablePadding>
          <ListItemButton sx={{ display: "flex", justifyContent: "center" }}>
            <Link to="/terms-and-conditions">
              <Btn onClick={toggle}>Terms & Conditions</Btn>
            </Link>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton sx={{ display: "flex", justifyContent: "center" }}>
            <a
              href="https://www.youtube.com/watch?v=n36aUE26x3k"
              target="blank"
            >
              <Btn
                variant="contained"
                sx={{
                  borderRadius: "4px",
                  background: "#4eaf51 !important",
                  color: "#ffffff",
                }}
              >
                Demo
              </Btn>
            </a>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton sx={{ display: "flex", justifyContent: "center" }}>
            <Link to="/login">
              <Btn>Login</Btn>
            </Link>
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{
          background: "#FFFFFF",
          boxShadow: "none",
          px: { xs: "1px", md: "60px" },
        }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            aria-label="menu"
            sx={{ mr: 2, display: { xs: "flex", sm: "none" } }}
            onClick={toggle}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: { xs: "center", sm: "start" },
            }}
          >
            <img src={Logo} alt="logo" />
          </Box>
          <Stack
            direction="row"
            display={{ xs: "none", sm: "flex" }}
            spacing={1}
          >
            {otherPath ? (
              <Link to="/">
                <Btn variant="text">Home</Btn>
              </Link>
            ) : (
              <Link2
                to="home"
                spy={true}
                smooth={true}
                offset={0}
                duration={1000}
              >
                <Btn variant="text" onClick={toggle}>
                  Home
                </Btn>
              </Link2>
            )}
            <Btn
              variant="text"
              id="fade-button"
              aria-controls={open ? "fade-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              Features
            </Btn>

            <Menu
              id="fade-menu"
              MenuListProps={{
                "aria-labelledby": "fade-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              TransitionComponent={Fade}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    height: 32,
                  },
                  "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: "50%",
                    transform: "translateX(50%) translateY(-50%) rotate(45deg)",
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "center", vertical: "top" }}
              anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
            >
              <Grid container spacing="24px" background="#ECFFD8" p="16px">
                <Grid item xs={6}>
                  <Link to="/features/inventory-module">
                    <Box
                      sx={{ cursor: "pointer", display: "flex", width: "100%" }}
                    >
                      <img height="24px" width="24px" src={Icon1} alt="" />
                      <Stack width="80%">
                        <MenuTitle>Inventory Management</MenuTitle>
                        <MenuTitle sx={{ fontWeight: 400 }}>
                          Warehouse, Racks etc
                        </MenuTitle>
                      </Stack>
                    </Box>
                  </Link>
                </Grid>
                <Grid item xs={6}>
                  <Link to="/features/mobile-apps-module">
                    <Box
                      sx={{ cursor: "pointer", display: "flex", width: "100%" }}
                    >
                      <img height="24px" width="24px" src={Icon2} alt="" />
                      <Stack width="80%">
                        <MenuTitle>Mobile Apps</MenuTitle>
                        <MenuTitle sx={{ fontWeight: 400 }}>
                          IOS & Android
                        </MenuTitle>
                      </Stack>
                    </Box>
                  </Link>
                </Grid>
                <Grid item xs={6}>
                  <Link to="/features/pos-module">
                    <Box
                      sx={{ cursor: "pointer", display: "flex", width: "100%" }}
                    >
                      <img height="24px" width="24px" src={Icon3} alt="" />
                      <Stack width="80%">
                        <MenuTitle>Point of Sale</MenuTitle>
                        <MenuTitle sx={{ fontWeight: 400 }}>
                          Sale, Invoices, Quotations etc
                        </MenuTitle>
                      </Stack>
                    </Box>
                  </Link>
                </Grid>
                <Grid item xs={6}>
                  <Link to="/features/delivery-module">
                    <Box
                      sx={{ cursor: "pointer", display: "flex", width: "100%" }}
                    >
                      <img height="24px" width="24px" src={Icon4} alt="" />
                      <Stack width="80%">
                        <MenuTitle>Delivery Management</MenuTitle>
                        <MenuTitle sx={{ fontWeight: 400 }}>
                          Vehicles, Transport etc
                        </MenuTitle>
                      </Stack>
                    </Box>
                  </Link>
                </Grid>
                <Grid item xs={6}>
                  <Link to="/features/financial-module">
                    <Box
                      sx={{ cursor: "pointer", display: "flex", width: "100%" }}
                    >
                      <img height="24px" width="24px" src={Icon5} alt="" />
                      <Stack width="80%">
                        <MenuTitle>Financials</MenuTitle>
                        <MenuTitle sx={{ fontWeight: 400 }}>
                          Profit, Ledger, Daybook etc
                        </MenuTitle>
                      </Stack>
                    </Box>
                  </Link>
                </Grid>
                <Grid item xs={6}>
                  <Link to="/features/hr-module">
                    <Box
                      sx={{ cursor: "pointer", display: "flex", width: "100%" }}
                    >
                      <img height="24px" width="24px" src={Icon6} alt="" />
                      <Stack width="80%">
                        <MenuTitle>HR Module</MenuTitle>
                        <MenuTitle sx={{ fontWeight: 400 }}>
                          Employee Registrations &
                        </MenuTitle>
                        <MenuTitle sx={{ fontWeight: 400 }}>
                          Management, salaries, timers etc
                        </MenuTitle>
                      </Stack>
                    </Box>
                  </Link>
                </Grid>
                <Grid item xs={6}>
                  <Link to="/features/online-store-module">
                    <Box
                      sx={{ cursor: "pointer", display: "flex", width: "100%" }}
                    >
                      <img height="24px" width="24px" src={Icon7} alt="" />
                      <Stack width="80%">
                        <MenuTitle>Online Store</MenuTitle>
                        <MenuTitle sx={{ fontWeight: 400 }}>
                          Create store, Manage Orders etc
                        </MenuTitle>
                      </Stack>
                    </Box>
                  </Link>
                </Grid>
              </Grid>
            </Menu>

            {/* {otherPath ? ( */}
            <Link to="/about-us">
              <Btn variant="text">About Us</Btn>
            </Link>
            {/* <Link to="/pricing">
              <Btn variant="text">Pricing</Btn>
            </Link> */}
            {/* ) : ( */}
            {/* <Link2
                to="about"
                spy={true}
                smooth={true}
                offset={0}
                duration={1000}
              >
                <Btn variant="text" onClick={toggle}>
                  About
                </Btn>
              </Link2>
            )} */}
            {/* <Link to="/pricing">
              <Btn variant="text">Pricing</Btn>
            </Link> */}
            {otherPath ? (
              <Link to="/">
                <Btn variant="text">Out Partners</Btn>
              </Link>
            ) : (
              <Link2
                to="partners"
                spy={true}
                smooth={true}
                offset={0}
                duration={1000}
              >
                <Btn variant="text" onClick={toggle}>
                  Out Partners
                </Btn>
              </Link2>
            )}
            <Link to="/terms-and-conditions">
              <Btn variant="text">Terms & Conditions</Btn>
            </Link>
            <a
              href="https://www.youtube.com/watch?v=n36aUE26x3k"
              target="blank"
            >
              <Btn
                variant="contained"
                sx={{
                  borderRadius: "4px",
                  background: "#4eaf51 !important",
                  color: "#ffffff",
                }}
              >
                Demo
              </Btn>
            </a>
            <Link to="/inventory/login">
              <Btn variant="text">Login</Btn>
            </Link>
            <Link>
            <Button 
               sx={{
                borderRadius: "4px",
                background: "#4eaf51 !important",
                color: "#ffffff",
              }}
            variant="contained" 
            color="success" 
            startIcon={<WhatsAppIcon />} 
            onClick={handleClickWhatsapp}
            style={{ backgroundColor: '#25D366', color: 'white' }}
        >
          Send message

        </Button>
            </Link>
          </Stack>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { xs: "50%", sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={toggle}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: { xs: "50%", sm: drawerWidth },
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}
